(function($) {
    // Toggles the mega menu
    $(function() {
        $(".explore-spire").on("click", function() {
            $("#mega-menu").show();
        });

        $("#close").on("click", function() {
            $("#mega-menu").hide();
        });
    });

    // Mega menu button functions
    $(function() {
        $("#btn-my-account").on("click", function() {
            $("#mega-menu").hide();
            window.location = "#/";
        });

        $("#btn-sign-out").on("click", function() {
            window.location = "/c/portal/logout";
        });
    });

    // Toggles the footer sections in mobile view
    $(function() {
        $("#footer-mobile-contact section h3, #footer-nav-menu section h3").on(
            "click",
            function() {
                $(this).toggleClass("expanded");
            }
        );
    });

    // Pins the pay multiple location bar to the top
    $(function() {
        $(document).on("scroll", function() {

            // phone
            if ($(window).width() > 0 && $(window).width() < 768) {
                if ($(document).scrollTop() > 350) {
                    $(".pay-multiple-accounts").addClass("shrink");
                } else {
                    $(".pay-multiple-accounts").removeClass("shrink");
                }
            }

            // tablet
            if ($(window).width() >= 768 && $(window).width() < 992) {
                if ($(document).scrollTop() > 250) {
                    $(".pay-multiple-accounts").addClass("shrink");
                } else {
                    $(".pay-multiple-accounts").removeClass("shrink");
                }
            }

            // desktop
            if ($(window).width() >= 992) {
                if ($(document).scrollTop() > 150) {
                    $(".pay-multiple-accounts").addClass("shrink");
                } else {
                    $(".pay-multiple-accounts").removeClass("shrink");
                }
            }
        });
    });
})(jQuery);
